// @ts-nocheck
import React, { useEffect, useRef } from 'react'
import { setCurrentStateProvince, useDispatch, useSelector } from '@ggs/store'
import { useAllEmbedSimpleMapScripts } from '@ggs/hooks'
import { getDrupalSetting, getWindow } from '@ggs/utils'
import { includes, delay, toLower } from 'lodash'

export const SimpleMap = () => {
  const baseUrl =
    getDrupalSetting('baseUrl') || `${process.env.REACT_APP_DRUPAL_BASE_URL}` || 'http://localhost'
  const mapRef = useRef(null)
  const dispatch = useDispatch()
  const selectedCountry = useSelector((state) => state.settings?.country || 'CA')
  const selectedStateProvince = useSelector((state) => state.settings?.stateProvince || '')
  const embedScripts = useAllEmbedSimpleMapScripts()
  const win = getWindow()

  /**
   * Load simple map.
   * @param {String} map
   * @param {String=} selectWidget
   * @return {void}
   */
  const loadMap = (map, selectWidget = null) => {
    map.load()

    if (selectWidget) {
      map.hooks.complete = () => {
        win[selectWidget].map = map
        win[selectWidget].max = 1
        win[selectWidget].selected_color = '#555759'

        // Deselect all maps
        if (win.simplemaps_canada_select
          && win.simplemaps_canada_select.selected
          && win.simplemaps_canada_select.selected.length > 0) {
          win.simplemaps_canada_select.deselect_all()
        }
        if (win.simplemaps_us_select
          && win.simplemaps_us_select.selected
          && win.simplemaps_us_select.selected.length > 0) {
          win.simplemaps_us_select.deselect_all()
        }
      }
    }

    // Logic to change options in the state filter by clicking to the map
    if (selectedCountry === 'US' || selectedCountry === 'CA') {
      map.hooks.click_state = (id) => {
        if (includes(win[selectWidget].selected, id)) {
          delay(() => {
            dispatch(setCurrentStateProvince(''))
          }, 100)
        } else {
          delay(() => {
            dispatch(setCurrentStateProvince(id))
          }, 100)
        }
      }
    }
  }

  /**
   * Clear simple map container except class.
   * @param {String} className
   * @return {void}
   */
  const clearMapContainerExceptClass = (className) => {
    const mapElement = mapRef.current
    const elements = mapElement.querySelectorAll(`:scope > *:not(.${className})`)
    elements.forEach((element) => {
      element.innerHTML = ''
    })
  }

  // This hook using only to load map by switching country in the filters.
  /* eslint-disable */
  useEffect(() => {
    if (embedScripts === 'ready') {
      switch (selectedCountry) {
        case 'US':
          loadMap(simplemaps_usmap, 'simplemaps_us_select')
          break
        case 'CA':
          loadMap(simplemaps_canadamap, 'simplemaps_canada_select')
          break
        case 'CAR':
          loadMap(simplemaps_caribbeanmap)
          break
        case 'EU':
          loadMap(simplemaps_europemap)
          break
        case 'ASI':
          loadMap(simplemaps_asiamap)
          break
        case 'MENA':
          clearMapContainerExceptClass('simple-map__country--mena')
          break
        default:
          break
      }
    }
  }, [selectedCountry, embedScripts])

  // Logic to select state in the map if it was selected in the state filter.
  useEffect(() => {
    if (selectedCountry === 'US' && win.simplemaps_us_select) {
      if (selectedStateProvince !== ''
        && win.simplemaps_us_select
        && selectedStateProvince in win.simplemaps_us_select.map.mapinfo.names
        && !includes(win.simplemaps_us_select.selected, selectedStateProvince)
      ) {
        win.simplemaps_us_select.select(selectedStateProvince)
      } else if (
        (
          selectedStateProvince === ''
          || selectedStateProvince === 'none'
          || !(selectedStateProvince in win.simplemaps_us_select.map.mapinfo.names)
        )
        && win.simplemaps_us_select
        && win.simplemaps_us_select.selected.length > 0
      ) {
        win.simplemaps_us_select.deselect_all()
      }
    } else if (selectedCountry === 'CA' && win.simplemaps_canada_select) {
      if (selectedStateProvince !== ''
        && win.simplemaps_canada_select
        && selectedStateProvince in win.simplemaps_canada_select.map.mapinfo.names
        && !includes(win.simplemaps_canada_select.selected, selectedStateProvince)
      ) {
        win.simplemaps_canada_select.select(selectedStateProvince)
      } else if (
        (
          selectedStateProvince === ''
          || selectedStateProvince === 'none'
          || !(selectedStateProvince in win.simplemaps_canada_select.map.mapinfo.names)
        )
        && win.simplemaps_canada_select
        && win.simplemaps_canada_select.selected.length > 0
      ) {
        win.simplemaps_canada_select.deselect_all()
      }
    }
  }, [selectedStateProvince])
  /* eslint-enable */

  return embedScripts === 'ready' && (
    <div className="simple-map" ref={mapRef}>
      <div id="map" className={`simple-map__country--${toLower(selectedCountry === 'MENA' ? 'not-active' : selectedCountry)}`}></div>
      {(selectedCountry === 'MENA') && (
        <div className={`simple-map__country--${toLower(selectedCountry)}`}>
          <img src={`${baseUrl}/modules/custom/t4_react/react-app/src/assets/mena-map.png`} alt="Mena map" width="597" height="450" />
        </div>
      )}
    </div>
  )
}
